import React, { useRef, useState, useEffect } from "react";

const TriStateCheckbox = ({ 
  value, 
  onStateChange, 
  disabled = false 
}: { 
  value: number, 
  onStateChange: any, 
  disabled?: boolean 
}) => {
  const [state, setState] = useState(value); // 0: unchecked, 1: checked, 2: indeterminate
  const checkboxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (checkboxRef.current) {
      if (state === 0) {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = false;
      } else if (state === 1) {
        checkboxRef.current.checked = true;
        checkboxRef.current.indeterminate = false;
      } else if (state === 2) {
        checkboxRef.current.checked = false;
        checkboxRef.current.indeterminate = true;
      }
    }

    // Notify parent about state change
    if (onStateChange) {
      onStateChange(state);
    }
  }, [state, onStateChange]);

  const handleClick = () => {
    if (!disabled) {
      setState((prevState) => (prevState + 1) % 3); // Cycle through states: 0 -> 1 -> 2 -> 0
    }
  };

  return (
    <div>
      <input
        type="checkbox"
        ref={checkboxRef}
        onClick={handleClick}
        className="form-checkbox"
        disabled={disabled}
      />
    </div>
  );
};

export default TriStateCheckbox;
